/* eslint-disable import/no-unresolved, curly, no-unused-expressions, no-extra-parens, no-shadow, no-return-assign, no-unused-vars */

import _ from 'lodash';
import Handlebars from 'handlebars';
import $ from 'jquery';

import z from 'app/common/z';
import { cloneAll, get, exists } from 'app/common/CommonUtils';
import _str from 'app/common/underscore-string';

import * as LegacyUtils from 'app/legacy/LegacyUtils';

// useful routines and methods
let useful,
  indexOf =
    [].indexOf ||
    function(item) {
      for (let i = 0, l = this.length; i < l; i++) {
        if (i in this && this[i] === item) return i;
      }
      return -1;
    };

useful = {
  QueryString: (function() {
    function _Class(queryString) {
      let pair, ref;
      this.queryString = queryString;
      this.queryString ||
        (this.queryString =
          (ref = window.document.location.search) != null
            ? ref.substr(1)
            : void 0);
      this.pairs = [];
      this.object = {};
      if (indexOf.call(this.queryString, '=') >= 0) {
        this.variables = this.queryString.split('&');
        this.pairs = function() {
          let j, len, ref1, results;
          ref1 = this.variables;
          results = [];
          for (j = 0, len = ref1.length; j < len; j++) {
            pair = ref1[j];
            results.push(pair.split('='));
          }
          return results;
        }.call(this);
        this.pairs = _.map(this.pairs, function(pair) {
          return [pair[0], decodeURIComponent(pair[1])];
        });
        this.object = _.fromPairs(this.pairs || []);
      }
    }

    return _Class;
  })(),

  /* given a <str> of `data`, return a short one-line summary of the data
   * with ellpises if necessary: ... a sample of the data ...
   */
  summarize: function(data, max) {
    let pos, s;
    if (max == null) {
      max = 50;
    }
    if (!exists(data) || data.length < max) {
      return data;
    }
    pos = Math.round(data.length / 2) - Math.round(max / 2);
    s = String(data)
      .substr(pos, max)
      .replace(/(\r\n|\n|\r)/gm, '');
    data = '... ' + s + ' ...';
    return data;
  },
  article: function(string, options) {
    let article, j, len, letter, v, vowel, vowels;
    if (options == null) {
      options = {};
    }
    vowels = ['a', 'e', 'i', 'o', 'u'];
    vowel = false;
    letter = string.toLowerCase()[0];
    for (j = 0, len = vowels.length; j < len; j++) {
      v = vowels[j];
      if (letter === v) {
        vowel = true;
      }
    }
    if (vowel) {
      article = 'an';
    }
    if (!vowel) {
      article = 'a';
    }
    if (options != null ? options.capitalize : void 0) {
      article = _str.capitalize(article);
    }
    if (options != null ? options.prepend : void 0) {
      return article + ' ' + string;
    } else {
      return article;
    }
  },

  // return the page of `needle` inside `haystack`, paginated by `perPage`
  whatPage: function(haystack, needle, perPage) {
    let idx;
    idx = 1;
    _.each(haystack, function(each, i) {
      if (each === needle) {
        idx = i + 1;
      }
    });
    return Math.ceil(idx / perPage);
  },

  // return the number of pages given `haystack` paginated by `perPage`
  maxPage: function(haystack, perPage) {
    return Math.ceil(haystack.length / perPage);
  },

  /* retrieve a string of errors associated with a failed ajax request to
   * the zapier api
   */
  errors: function(xhr) {
    let body, e, error, ref, ref1;
    try {
      body = JSON.parse(xhr.responseText);
      error =
        get(body, ['error', 'join', [' ']]) ||
        (body != null
          ? (ref = body.errors) != null
            ? ref.join(' ')
            : void 0
          : void 0);
    } catch (_error) {
      e = _error;
      error = null;
    }
    if (!error) {
      if (exists(xhr.status) && xhr.statusText != null) {
        error = xhr.status + ': ' + xhr.statusText;
      } else {
        error =
          (ref1 = xhr.responseText) != null ? ref1.substring(0, 150) : void 0;
      }
    }
    return error;
  },

  /* enables you to open a popup
   * (ex. options: 'height=600,width=980,resizable=yes,scrollbars=yes')
   */
  open: function(url, target, options) {
    let win;
    if (target == null) {
      target = '_blank';
    }
    win = exists(window) ? window.open(url, target, options) : void 0;
    if (win && win.focus) {
      win.focus();
    }
    return win;
  },

  // navigate to a url by refreshing the page
  goto: function(url) {
    return exists(window) ? (window.location.href = url) : void 0;
  },

  /* method called as wrapper for all JST templates (returns another function)
   * compile, render, and return a given handlebars template and context
   */
  template: function(templateString) {
    return extraContext => {
      // return the raw template string if called with `JST[...](false)`
      let context;
      if (extraContext === false) {
        return templateString;
      }
      z.app.trigger('render');
      context = _.defaults(
        {},
        z.cfg.renderContext,
        {
          z,
        },
        extraContext,
        window.BASE_CONFIG
      );
      return z.useful.render(templateString, context);
    };
  },

  // quickly render a handlebars template given string and context
  render: function(templateString, context, options) {
    if (options == null) {
      options = {};
    }
    return Handlebars.compile(templateString, options).call(this, context);
  },

  // take an array and split in to an arbitrary number of chunks
  chunks: function(array, chunkSize) {
    return [].concat.apply(
      [],
      _.map(array, function(item, i) {
        return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
      })
    );
  },

  /* does a decent job of balancing into N chunks of an arbitrary length
   * fails if you have way too many chunks (adds empty ones at the end)
   */
  equalChunks: function(array, chunks) {
    let chunked;
    chunked = this.chunks(array, Math.ceil(array.length / chunks));
    return [].concat.apply(
      [],
      _.map(_.range(chunks), function(item, i) {
        return [chunked[i] || []];
      })
    );
  },

  // cross browser viewport height and width
  viewportSize: function() {
    let viewPortHeight, viewPortWidth;
    if (typeof window.innerWidth !== 'undefined') {
      viewPortWidth = window.innerWidth;
      viewPortHeight = window.innerHeight;
    } else if (
      typeof document.documentElement !== 'undefined' &&
      typeof document.documentElement.clientWidth !== 'undefined' &&
      document.documentElement.clientWidth !== 0
    ) {
      viewPortWidth = document.documentElement.clientWidth;
      viewPortHeight = document.documentElement.clientHeight;
    } else {
      viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
      viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
    }
    return [viewPortWidth, viewPortHeight];
  },

  // cross browser viewport scroll offsets
  viewportScroll: function() {
    let scrollx, scrolly;
    scrollx = $(window).scrollLeft();
    scrolly = $(window).scrollTop();
    return [scrollx, scrolly];
  },
  elClippedByScreenBottom: function(el) {
    let edges, offset, size, viewport;
    offset = $(el).offset();
    if (offset == null) {
      return false;
    }
    offset.left = offset.left - z.useful.viewportScroll()[0];
    offset.top = offset.top - z.useful.viewportScroll()[1];
    size = {
      width: $(el).outerWidth(),
      height: $(el).outerHeight(),
    };
    viewport = z.useful.viewportSize();
    edges = [];

    /** top
     * edges.push (offset.top < 0)
     */

    /** left
     * edges.push (offset.left < 0)
     */

    /** right
     * edges.push (offset.left+size.width > viewport[0])
     */

    // bottom
    edges.push(offset.top + size.height > viewport[1]);

    // return true if any of the edges are true (indicating the edge is off the screen)
    return _.some(edges, function(edge) {
      return edge;
    });
  },

  // remove extra whitespace from a string and return it
  squish: function(string) {
    return string.replace(/\s/g, '');
  },

  /* disable background scrolling for an element when the mouse is positioned
   * inside `el`
   * have to keep a log of every el that it's enabled on (so we dont disable it until the last one is removed)
   */
  noBGScrollEls: [],
  noBGScroll: function($el) {
    let id;
    if ($el.attr('data-bgscroll-id') != null) {
      // dont activate twice for same el
      return $el.attr('data-bgscroll-id');
    }
    id = _.uniqueId();
    $el.attr('data-bgscroll-id', id);
    z.useful.noBGScrollEls[id] = $el;
    $el.on('mousewheel DOMMouseScroll', function(e) {
      let scrollTo;
      scrollTo = null;
      if (e.type === 'mousewheel') {
        scrollTo = e.originalEvent.wheelDelta * -1;
      } else if (e.type === 'DOMMouseScroll') {
        scrollTo = 40 * e.originalEvent.detail;
      }
      if (scrollTo) {
        e.preventDefault();
        return $(this).scrollTop(scrollTo + $(this).scrollTop());
      }
      return undefined;
    });
    return id;
  },

  /* disable the previous noBGScroll bind. Should be set up inside an
   * event bind on the `remove` event in a view. eg:
   *   @on 'remove', (=> z.useful.noBGScrollOff @$el)
   */
  noBGScrollOff: function(id) {
    let $el;
    $el = cloneAll(z.useful.noBGScrollEls[id]);
    delete z.useful.noBGScrollEls[id];
    return $el.off('mousewheel DOMMouseScroll');
  },
  starLoader: function($el, css) {
    let text, width;
    if (css == null) {
      css = '';
    }

    // old text
    text = $el.attr('data-text');
    if (!exists(text) || (text != null ? text.length : void 0) === 0) {
      text = $el.text();
    }
    width = $el.outerWidth();
    $el.attr('data-text', text);
    $el.css('width', width);
    return $el.html('<div class="spinning-star ' + css + '"></div>');
  },
  starLoaderStop: function($el) {
    let text;
    text = $el.attr('data-text');
    $el.css('width', null);
    return $el.text(text);
  },

  promiseRefreshChrome(options) {
    return new Promise((resolve, reject) => {
      this.refreshChrome({
        ...options,
        success: resolve,
        error: reject,
      });
    });
  },

  /* download the chrome (footer) against and replace them inside the DOM
   * used so we can do logged out/logged in refreshses without needing to do
   * hard navigation changes
   */
  refreshChrome: function(options = {}) {
    if (!options.success) {
      return this.promiseRefreshChrome(options);
    }

    // remove superuser topbar
    $('.superuser-topbar').remove();
    return $.ajax('/chrome.html', {
      success: (function(_this) {
        return function(html) {
          let $dom, $footer;
          $dom = $('<div>').html(html);
          $footer = $dom.find('#footer');

          // Might not be a place to put the footer.
          if ($('#react-root-app').length > 0) {
            if ($('#footer').length === 0) {
              $('#react-root-app').after('<div id="footer"/>');
            }
            if ($('#support').length === 0) {
              $('#react-root-app').after(
                `<div id="support" class="support-sidebar" role="complementary" aria-label="Support menu">
                    <div class="support-button">Get Help</div>
                  </div>`
              );
            }
          }

          // now replace into DOM
          $('#footer').replaceWith($footer);

          return options != null
            ? options.success.apply(_this, arguments)
            : void 0;
        };
      })(this),
      error: (function(_this) {
        return function() {
          return options != null
            ? options.error.apply(_this, arguments)
            : void 0;
        };
      })(this),
    });
  },

  /** start or continue an a/b test given a string name and array of variants
   * # which are also strings, you'll always be returned the same variant
   * # to switch between in your logic
   * ab: (name, variants) ->
   *    name = 'AB Test: ' + name
   *    selected_variant = z.store.get name
   *    if selected_variant == null
   *       selected_variant = variants[Math.floor(Math.random()*variants.length)]
   *       z.store.set name, selected_variant
   *    # optionally, track event like so:
   *    #   window.track.new 'some: event', {'AB Test: ' + name: selected_variant}
   *    return selected_variant
   */

  /* given a full series of ids (131, 132, 133, 134) and a partial series of
   * ids (131, 133) return an array of length equal to partial series length
   * where each index corresponds to the relative order it matches in full series
   * in the example above, we should return (1, 3)
   * will return false if any partialSeries are not found inside fullSeries
   */
  orderRelative: function(fullSeries, partialSeries) {
    let orderRelative, orderedFullSeries;
    orderedFullSeries = _.sortBy(fullSeries, function() {
      return arguments[0];
    });
    orderRelative = _.map(partialSeries, function(i) {
      return _.indexOf(orderedFullSeries, i);
    });
    if (
      _.some(orderRelative, function(i) {
        return i === -1;
      })
    ) {
      return false;
    }
    orderRelative = _.map(orderRelative, function(i) {
      return i + 1;
    });
    return orderRelative;
  },
  isDescendant: function(parent, child) {
    let node;
    node = child.parentNode;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  },
  isIterable: function(value) {
    let isArray, isObject;
    isObject = _.isObject(value) && !_.isFunction(value);
    isArray = _.isArray(value);
    return Boolean(isObject || isArray);
  },
  uniqueLengthId: function(length) {
    let id;
    if (length == null) {
      length = 8;
    }
    id = '';
    while (id.length < length) {
      id += Math.random()
        .toString(36)
        .substr(2);
    }
    return id.substr(0, length);
  },
  getISODate: function(date) {
    // we got a timestamp instead, make it a
    let day, month, year;
    if (typeof date === 'string') {
      date = new Date(date);
    } else if (typeof date === 'number') {
      // assume int..
      date = new Date(date * 1000);
    }
    day = z.useful.zfill(date.getDate(), 2);

    // zero based
    month = z.useful.zfill(date.getMonth() + 1, 2);
    year = date.getFullYear();
    return year + '-' + month + '-' + day;
  },
  zfill: function(n, p, pad_char) {
    let pad;
    if (pad_char == null) {
      pad_char = '0';
    }
    n = '' + n;
    if (n.length > p) {
      return n;
    }
    pad = new Array(1 + p).join(pad_char);
    return (pad + n).slice(-pad.length);
  },
  centsToDollars: function(num) {
    let cents, dollars;
    num = Number(num);
    if (num > 0) {
      dollars = Math.floor(num / 100);
    } else if (num < 0) {
      dollars = Math.ceil(num / 100);
    } else {
      dollars = 0;
    }
    cents = '0' + (num - dollars * 100);
    return dollars + '.' + cents.substr(cents.length - 2);
  },
};

_.extend(z.useful, useful);

window.JST = useful.template;
